/**
 * Formatting shared by the Infinity Touch case popup (components/admin/InfinityCaseDetail)
 * and the case PDF it downloads (components/admin/InfinityCasePdf), so the document
 * reads exactly like the screen it was downloaded from.
 */

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
export const fmt = (d) => (d ? new Date(d).toLocaleString() : "—");
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString() : "—");

// Same one-line address rendering the family sees on the customer site
// (customer-infinity/InfinityOrderList.jsx), so both panels read identically.
export const addrLine = (a) =>
  a ? [a.line1, a.line2, a.city, a.state, a.postal_code, a.country].filter(Boolean).join(", ") : "";

const FINGER = { "01": "Left Baby", "02": "Left Ring", "03": "Left Middle", "04": "Left Index", "05": "Left Thumb", "06": "Right Thumb", "07": "Right Index", "08": "Right Middle", "09": "Right Ring", "10": "Right Baby" };
export const describeTarget = (t) => (!t ? "Print" : t.finger ? `Finger · ${FINGER[t.finger] || t.finger}` : t.target || t.kind || "Print");
